import { createBrowserRouter } from 'react-router-dom';
import { ProtectedRoute } from '@nexdel/core/auth';
import { AppLayout } from '@nexdel/ui/layout/AppLayout';
import { MfaGate } from '@nexdel/ui/layout/MfaGate';
import { lazy, Suspense } from 'react';

import Login from '../pages/Login';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';
import AcceptInvite from '../pages/AcceptInvite';
import NotFound from '../pages/Dashboard'; // reuse as fallback for now

const Dashboard = lazy(() => import('../pages/Dashboard'));
const Mandates = lazy(() => import('../pages/Mandates'));
const MandateDetail = lazy(() => import('../pages/MandateDetail'));
const Requirements = lazy(() => import('../pages/Requirements'));
const RequirementDetail = lazy(() => import('../pages/RequirementDetail'));
const Submissions = lazy(() => import('../pages/Submissions'));
const Profile = lazy(() => import('../pages/Profile'));
const Notifications = lazy(() => import('../pages/Notifications'));

const fallback = <div className="flex-1 flex items-center justify-center text-muted-foreground text-sm">Loading…</div>;

export const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  { path: '/forgot-password', element: <ForgotPassword /> },
  { path: '/reset-password', element: <ResetPassword /> },
  { path: '/accept-invite', element: <AcceptInvite /> },

  {
    element: (
      <ProtectedRoute>
        <MfaGate>
          <AppLayout />
        </MfaGate>
      </ProtectedRoute>
    ),
    children: [
      { path: '/', element: <Suspense fallback={fallback}><Dashboard /></Suspense> },
      { path: '/dashboard', element: <Suspense fallback={fallback}><Dashboard /></Suspense> },
      { path: '/mandates', element: <Suspense fallback={fallback}><Mandates /></Suspense> },
      { path: '/mandates/:id', element: <Suspense fallback={fallback}><MandateDetail /></Suspense> },
      { path: '/requirements', element: <Suspense fallback={fallback}><Requirements /></Suspense> },
      { path: '/requirements/:id', element: <Suspense fallback={fallback}><RequirementDetail /></Suspense> },
      { path: '/submissions', element: <Suspense fallback={fallback}><Submissions /></Suspense> },
      { path: '/profile', element: <Suspense fallback={fallback}><Profile /></Suspense> },
      { path: '/notifications', element: <Suspense fallback={fallback}><Notifications /></Suspense> },
    ],
  },

  { path: '*', element: <NotFound /> },
]);
